var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaypal2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_174861",
    clipPath: "url(#clip0_8100_2183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.5065 10.3344C33.5742 9.78398 33.6096 9.22359 33.6096 8.65492C33.6096 3.875 29.7347 0 24.9547 0H10.4904C9.58059 0 8.8038 0.657031 8.65286 1.55422L3.32317 33.232C3.13192 34.3687 4.00817 35.4045 5.16075 35.4045H10.4507C11.3605 35.4045 12.1519 34.748 12.3028 33.8507C12.3028 33.8507 12.3116 33.7981 12.3275 33.7034H12.3276L11.5904 38.0852C11.422 39.087 12.1943 40 13.2101 40H17.838C18.64 40 19.3247 39.4209 19.4576 38.6301L20.7724 30.816C20.999 29.469 22.1652 28.4827 23.5311 28.4827H24.7468C31.3507 28.4827 36.7042 23.1291 36.7042 16.5253C36.7042 13.9699 35.4411 11.7111 33.5065 10.3344Z",
    fill: "#002987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.5055 10.3345C32.6779 17.0672 26.9396 22.2806 19.9832 22.2806H15.9468C15.0358 22.2806 14.249 22.8874 14.0022 23.7453L11.5896 38.0851C11.4211 39.087 12.1933 40.0001 13.2092 40.0001H17.8371C18.639 40.0001 19.3237 39.421 19.4567 38.6302L20.7714 30.8161C20.9981 29.4691 22.1643 28.4828 23.5301 28.4828H24.7459C31.3498 28.4828 36.7032 23.1292 36.7032 16.5254C36.7032 13.97 35.4401 11.7112 33.5055 10.3345Z",
    fill: "#0085CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.9447 22.2802H19.981C26.9375 22.2802 32.6758 17.0669 33.5034 10.3342C32.2621 9.45094 30.7452 8.92969 29.1057 8.92969H18.5705C17.3711 8.92969 16.347 9.79586 16.1479 10.9787L14 23.7449C14.2468 22.887 15.0337 22.2802 15.9447 22.2802Z",
    fill: "#00186A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8100_2183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal2);
export default __webpack_public_path__ + "static/media/paypal2.bcd8c6026b8f0f0ad930ccc3b311c3f3.svg";
export { ForwardRef as ReactComponent };